const { Core, onBlazeLoad, Utils } = Global;
const { $toggleDisplay } = Utils;

const ACTIVE_CLASSNAME = 'blaze-active';

customElements.define('slideshow-blaze', class extends Core {
    elements = {
        $: ['blaze', ['nav']]
    }

    propTypes = {
        loop: Boolean,
        'autoplay-speed': Number,
        'initial-index': Number,
        'swipe-on-desktop': Boolean,
        'ignore-resize': Boolean
    }

    render() {
        this.options = {
            slideGap: '0px',
            loop: this.prop('loop'),
            slidesToShow: 1,
            draggable: this.prop('swipe-on-desktop')
        }
        this._setAutoplay();

        onBlazeLoad(this._initBlaze.bind(this));
    }

    destroy() {
        if(this.slider) {
            this.slider.destroy();
        }
    }

    _setAutoplay() {
        if(!!this.prop('autoplay-speed')) {
            this.options = {
                ...this.options,
                enableAutoplay: true,
                autoplayInterval: this.prop('autoplay-speed')*1,
            }
        }
    }

    _initBlaze() {
        if(!window.BlazeSlider) {
            // sanity check
            return;
        }
        this.slider = new window.BlazeSlider(this.$('blaze'), {
            all: this.options,
            '(max-width: 992px)': {
                draggable: true
            }
        })


        if(this.prop('ignore-resize')) {
            this.slider.refresh = () => {};
        }
        if(this.prop('initial-index')) {
            this.slideTo(this.prop('initial-index'));
        }

        this._handleActiveSlideChange();
        this._toggleNavigation();

        if(this.closest(".slideshow-hero")){
           setTimeout(() => {
          this.closest(".slideshow-hero").classList.add("rendered");
           },500);
        }

      var needInterval = false;
      let temp = this.slider.el.closest('.shopify-section').getElementsByTagName("template")[0];
      if (temp) {
        let clon = temp.content.cloneNode(true);
  
        
        clon.querySelectorAll('[data-slideshow-slide]').forEach(function (item) {
          if (item.getAttribute('data-end-date') || item.getAttribute('data-start-date')) {
            needInterval = true;
          }
        });
  
        if (needInterval) {
          var needRefresh = false;
            var sliderItems = this.slider.el.querySelectorAll('.blaze-track > div');
            var totalSlides = sliderItems.length;         
            if (sliderItems.length) {
              sliderItems.forEach(function (item) {
                if (item.getAttribute('data-end-date') || item.getAttribute('data-start-date')) {
                  if(item.getAttribute('data-start-date') != "" && item.getAttribute('data-start-date') != null){
                    var startDate = new Date(item.getAttribute('data-start-date'));
                  }else{
                    var startDate = Date.now();
                  }

                  if(item.getAttribute('data-end-date') != "" && item.getAttribute('data-end-date') != null){
                    var endDate = new Date(item.getAttribute('data-end-date'));
                  }else{
                    var endDate = new Date(24 * 3600 * 1000 * 365 * 99);
                  }
                  
                  
                  if (Date.now() < startDate || Date.now() > endDate) {
                    item.remove();
                    totalSlides = totalSlides - 1;
                    needRefresh = true;
                  }
                }
              });
            }
  
            clon.querySelectorAll('[data-slideshow-slide]').forEach(function (item) {
              if (item.getAttribute('data-end-date') || item.getAttribute('data-start-date')) {
                  if(item.getAttribute('data-start-date') != "" && item.getAttribute('data-start-date') != null){
                    var startDate = new Date(item.getAttribute('data-start-date'));
                  }else{
                    var startDate = Date.now();
                  }

                  if(item.getAttribute('data-end-date') != "" && item.getAttribute('data-end-date') != null){
                    var endDate = new Date(item.getAttribute('data-end-date'));
                  }else{
                    var endDate = new Date(24 * 3600 * 1000 * 365 * 99);
                  }
                

                var needItem = true;
                sliderItems.forEach(function (el) {
                  if (item.getAttribute('data-block-id') == el.getAttribute('data-block-id')) {
                    needItem = false;
                  }
                });
                
                if (Date.now() > startDate && Date.now() < endDate && needItem) {
                  sliderItems.forEach(function (el) {
                    if (+el.getAttribute('data-index') + 1 == +item.getAttribute('data-index')) {
                      el.after(item);
                      totalSlides = totalSlides + 1;
                      needRefresh = true;
                    }
                  });
                }
              }
            });
  
            if (needRefresh) {
              this.slider.totalSlides = totalSlides;
              this.slider.refresh();
              needRefresh = false;
            }
          setInterval(() => {
            var needRefresh = false;
            var sliderItems = this.slider.el.querySelectorAll('.blaze-track > div');
            var totalSlides = sliderItems.length;         
            if (sliderItems.length) {
              sliderItems.forEach(function (item) {
                if (item.getAttribute('data-end-date') || item.getAttribute('data-start-date')) {
                  if(item.getAttribute('data-start-date') != "" && item.getAttribute('data-start-date') != null){
                    var startDate = new Date(item.getAttribute('data-start-date'));
                  }else{
                    var startDate = Date.now();
                  }

                  if(item.getAttribute('data-end-date') != "" && item.getAttribute('data-end-date') != null){
                    var endDate = new Date(item.getAttribute('data-end-date'));
                  }else{
                    var endDate = new Date(24 * 3600 * 1000 * 365 * 99);
                  }
                  
                  
                  if (Date.now() < startDate || Date.now() > endDate) {
                    item.remove();
                    totalSlides = totalSlides - 1;
                    needRefresh = true;
                  }
                }
              });
            }
  
            clon.querySelectorAll('[data-slideshow-slide]').forEach(function (item) {
              if (item.getAttribute('data-end-date') || item.getAttribute('data-start-date')) {
                  if(item.getAttribute('data-start-date') != "" && item.getAttribute('data-start-date') != null){
                    var startDate = new Date(item.getAttribute('data-start-date'));
                  }else{
                    var startDate = Date.now();
                  }

                  if(item.getAttribute('data-end-date') != "" && item.getAttribute('data-end-date') != null){
                    var endDate = new Date(item.getAttribute('data-end-date'));
                  }else{
                    var endDate = new Date(24 * 3600 * 1000 * 365 * 99);
                  }
                

                var needItem = true;
                sliderItems.forEach(function (el) {
                  if (item.getAttribute('data-block-id') == el.getAttribute('data-block-id')) {
                    needItem = false;
                  }
                });
                
                if (Date.now() > startDate && Date.now() < endDate && needItem) {
                  sliderItems.forEach(function (el) {
                    if (+el.getAttribute('data-index') + 1 == +item.getAttribute('data-index')) {
                      el.after(item);
                      totalSlides = totalSlides + 1;
                      needRefresh = true;
                    }
                  });
                }
              }
            });
  
            if (needRefresh) {
              this.slider.totalSlides = totalSlides;
              this.slider.refresh();
              needRefresh = false;
            }
          }, 1000);
        }
      }
    }

    _handleActiveSlideChange() {
        this._updateActiveSlide();
        this.slider.onSlide(this._updateActiveSlide.bind(this))
    }

    
    _updateActiveSlide() {
        // since blaze slides are dyamic, active one is always 0
        const currentSlide = this.slider.slides.item(0);

        if(currentSlide === this._activeSlide) {
            return;
        }

        if(this._activeSlide) {
            this._activeSlide.classList.remove(ACTIVE_CLASSNAME);
        }

        this._activeSlide = currentSlide;
        this._activeSlide.classList.add(ACTIVE_CLASSNAME);
    }

    _toggleNavigation() {
        this.$('nav')?.map(item => $toggleDisplay(item, this.slider.totalSlides > 1));
    }

    slideTo(index) {
        // implemented based on https://github.com/blaze-slider/blaze-slider/blob/main/blaze-slider/src/utils/autoplay.ts
        // this is not ideal, but it's working
        // will use it untill official update
        // as far as I know there is no way to move it to an index. stateIndex is not a setter
        const target = this.slider.stateIndex - index;
        const dir = target > 0 ? 'prev': 'next';
        this.slider[dir](Math.abs(target));
    }
})